// extracted by mini-css-extract-plugin
export default {"spacer":"account-support-settings_spacer__SrJB7","hiddenButton":"account-support-settings_hiddenButton__cwBma","subsection":"account-support-settings_subsection__UKcjQ"};